// extracted by mini-css-extract-plugin
export default {"add_faq":"AddFAQ_add_faq__qaar8","section":"AddFAQ_section__EhKaL","error":"AddFAQ_error__E6zSQ","update_message":"AddFAQ_update_message__mMg4K"};